module.exports = __webpack_public_path__ + "assets/795fb7b75ff21905a672f506b65827d1.mp4";